import React, { FC } from 'react'
import { Dialog } from '../../ui/Dialog/Dialog'
import { SendFill } from '../../../assets/icons'
import { Typography } from '../../ui/Typography/Typography'
// import { L_HTML } from '../../providers/Lokalise'
import { Button } from '../../ui/Button/Button'
import { L } from '../../providers/Lokalise'

export interface WarningDialogProps {
    show?: boolean
    onClose?: () => void
    title: string
    description: string
    buttonText: string
    icon?: JSX.Element
}

const WarningDialog: FC<WarningDialogProps> = ({
    show,
    onClose,
    title = '',
    description = '',
    buttonText = '',
    icon,
}) => {
    if (!show) return null

    return (
        <Dialog trigger={null} defaultOpen hideClose icon={icon}>
            <Typography
                style={{ marginBottom: '30px' }}
                size="L"
                align="center"
            >
                {title}
            </Typography>
            <Typography
                tag="p"
                size="S"
                style={{ marginBottom: '30px' }}
                align="center"
            >
                {description}
            </Typography>
            <Button size="xlarge" onClick={() => onClose && onClose()}>
                {buttonText}
            </Button>
        </Dialog>
    )
}

export { WarningDialog }
